import { useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import TopBar from "@/components/vu/TopBar";
import Nav from "@/components/vu/Nav";
import Hero from "@/components/vu/Hero";
import TrustStrip from "@/components/vu/TrustStrip";
import ServicePills from "@/components/vu/ServicePills";
import About from "@/components/vu/About";
import Clash from "@/components/vu/Clash";
import Services from "@/components/vu/Services";
import Process from "@/components/vu/Process";
import Testimonials from "@/components/vu/Testimonials";
import WorkGallery from "@/components/vu/WorkGallery";
import Pricing from "@/components/vu/Pricing";
import FAQ from "@/components/vu/FAQ";
import Contact from "@/components/vu/Contact";
import FinalCTA from "@/components/vu/FinalCTA";
import Footer from "@/components/vu/Footer";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const checkoutStatus = params.get("checkout");
        const sessionId = params.get("session_id");

        if (checkoutStatus === "success" && sessionId) {
            axios.get(`${API}/checkout/session/${sessionId}`)
                .then(({ data }) => {
                    if (data.status === "paid") {
                        toast.success("Payment successful — welcome aboard! We'll be in touch shortly.");
                        if (window.gtag) {
                            window.gtag('event', 'purchase', {
                                transaction_id: sessionId,
                                currency: (data.currency || 'usd').toUpperCase(),
                                value: data.amount_total,
                            });
                        }

                        if (window.fbq) {
                            window.fbq('track', 'Purchase', {
                                value: data.amount_total,
                                currency: (data.currency || 'usd').toUpperCase(),
                            });
                        }
                    }
                })
                .catch((err) => console.error("Failed to verify checkout session", err))
                .finally(() => {
                    // Clean the query params so a page refresh doesn't re-fire the event
                    window.history.replaceState({}, document.title, window.location.pathname);
                });
        } else if (checkoutStatus === "cancelled") {
            toast.info("Checkout cancelled — no charge was made.");
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, []);

    return (
        <main data-testid="home-page">
            <TopBar />
            <Nav />
            <Hero />
            <TrustStrip />
            <ServicePills />
            <About />
            <Pricing />
            <Services />
            <WorkGallery />
            {/* <Clash /> */}
            <Process />
            <Testimonials />
            <FAQ />
            <Contact />
            <FinalCTA />
            <Footer />
        </main>
    );
}